import { call, put, takeLatest, select } from "redux-saga/effects";

import { getCoupon, validateCoupon } from "./CartApis";
import * as ACTIONS from "./CartActions";
import * as TYPES from "./CartTypes";
import { setErrorMessage } from "../Error/ErrorAction";
import { ALL_DELIVERY_TYPES, COUPONS, CURRENCY } from "../../utils/Constants";

// Replace with your sagas
export function* sagasCouponRequest({ payload }) {
  try {
    const hotelKey = payload;
    if (!hotelKey) {
      throw new Error("Something went wrong with the hotel key");
    }

    const response = yield call(getCoupon, hotelKey);
    if (!response?.data?.data) {
      throw new Error("Something went wrong with the response");
    }

    yield put(ACTIONS.getCouponReceive(response.data.data));
  } catch (err) {
    yield put(ACTIONS.getCouponReceive([]));
  }
}

export function* sagasValidateCoupon({ state, payload }) {
  try {
    const { hotelId, code } = payload;
    if (!hotelId) {
      throw new Error("Something went wrong with the hotel id");
    }

    const response = yield call(validateCoupon, hotelId, code);
    const coupon = response?.data?.data;
    // console.log("responseeeeeeee", response);
    //checking coupon is applicabile
    if (coupon?.id) {
      const { priceSummary, checkoutDetails, data } = yield select(
        (state) => state.cart
      );

      //   const getPrice = (coupon) => {
      //     if (coupon?.rules?.type === COUPONS.ITEM_DISCOUNT) {
      //       const applicableItems = JSON.parse(coupon?.items) || [];
      //       const validItemsInCart = data?.filter((item) =>
      //         applicableItems.includes(item.itemId)
      //       );
      //       let itemTotal = 0;
      //       validItemsInCart.forEach((item) => {
      //         const itemPrice = item?.count * item?.sale_price;
      //         itemTotal = itemTotal + itemPrice;
      //       });
      //       return Number(itemTotal);
      //     } else {
      //       return Number(priceSummary?.subTotal);
      //     }
      //   };

      const checkItemDiscountApplicability = (coupon) => {
        if (
          coupon?.rules?.type === COUPONS.ITEM_DISCOUNT &&
          coupon?.items &&
          coupon?.items?.length > 0
        ) {
          const applicableItems = JSON.parse(coupon?.items) || [];
          const validItemsInCart = data?.filter((item) =>
            applicableItems.includes(item.itemId)
          );
          // This condition for: 100% discount item can have only 1 quantity of that particular item
          if (
            applicableItems?.length === 1 &&
            coupon?.result?.DISCOUNT === 100 &&
            validItemsInCart?.length === 1 &&
            validItemsInCart[0]?.count > 1
          ) {
            return false;
            // } else return !!validItemsInCart.length;
          } else {
            //  yield put(ACTIONS.getCouponReceive(coupon));
            return true;
          }
        } else return true;
      };

      //check if it is exposed coupon or not
      if (checkItemDiscountApplicability(coupon)) {
        const applicableItems = JSON.parse(coupon?.items) || [];
        const validItemsInCart = data?.filter((item) =>
          applicableItems.includes(item.itemId)
        );
        // check greater than subtotal
        if (
          coupon?.rules?.APPLICABLE_FOR === checkoutDetails?.orderType ||
          coupon?.rules?.APPLICABLE_FOR === ALL_DELIVERY_TYPES
        ) {
          //   check delivery type
          if (
            Number(priceSummary?.subTotal) >
            Number(coupon?.rules?.MIN_ORDER_VALUE)
          ) {
            // if (validItemsInCart?.length > 0) {
            //   yield put(ACTIONS.selectCoupon(coupon));
            // }
            // //if coupon is applicable
            yield put(ACTIONS.getCouponReceive([response?.data?.data]));
          } else {
            //if coupon is not applicable
            yield put(
              setErrorMessage({
                message: `Order value should be more than ${CURRENCY.SIGN}${coupon?.rules?.MIN_ORDER_VALUE}`,
                showAs: "dialog",
              })
            );
          }
        } else {
          //if coupon is not applicable
          yield put(
            setErrorMessage({
              message: `Only applicable for ${
                coupon?.rules?.APPLICABLE_FOR === COUPONS.CART_DISCOUNT
                  ? "cart discount"
                  : "item discount"
              }`,
              showAs: "dialog",
            })
          );
        }
      } else {
        //if coupon is not applicable
        yield put(
          setErrorMessage({
            message: `Invalid coupon`,
            showAs: "dialog",
          })
        );
      }

      //   if (
      //     Number(priceSummary?.subTotal) >
      //       Number(coupon?.rules?.MIN_ORDER_VALUE) &&
      //     (coupon?.rules?.APPLICABLE_FOR === checkoutDetails?.orderType ||
      //       coupon?.rules?.APPLICABLE_FOR === ALL_DELIVERY_TYPES)
      //   ) {
      //     //if coupon is applicable
      //     yield put(ACTIONS.selectCoupon(coupon));
      //   } else {
      //     //if coupon is not applicable
      //     yield put(
      //       setErrorMessage({
      //         message: `Minimum order value is atleast $${coupon?.rules?.MIN_ORDER_VALUE}`,
      //         showAs: "dialog",
      //       })
      //     );
      //   }
    } else {
      yield put(
        setErrorMessage({
          message: "Invalid coupon",
          showAs: "dialog",
        })
      );
    }
  } catch (err) {
    yield put(
      setErrorMessage({
        message: "Something went wrong",
        showAs: "dialog",
      })
    );
  }
}

export function* CartSaga() {
  yield takeLatest(TYPES.GET_COUPON_REQUEST, sagasCouponRequest);
}

export function* VerifyCouponSaga() {
  yield takeLatest(TYPES.VALIDATE_COUPON, sagasValidateCoupon);
}
